import React from "react"
import { useUser } from "../contexts/UserContext"
import { Navigate } from "react-router-dom"

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user } = useUser()

    if (!user || !allowedRoles.includes(user.role)) {
        return <Navigate to="/login" replace />
    }

    return children
}

export default ProtectedRoute
